<h2 mat-dialog-title>Reply to review</h2>

<mat-dialog-content class="flex flex-col gap-4 ">
  <div class="rounded-lg border border-gray-200 p-3 text-sm text-gray-700">
    <div  class="font-medium">Author: {{ review.authorName || 'Unknown author' }}</div>
    <div  >Dealer: {{ review.dealerName || 'Unknown dealer' }}</div>
    <p  class="mt-2 text-gray-600 max-h-12 overflow-auto">{{ review.response }}</p>
  </div>

  <mat-tab-group
    class="w-full mt-4 overflow-x-hidden"
    [selectedIndex]="activeTab === 'select' ? 0 : 1"
    (selectedIndexChange)="onTabChange($event)">
    <mat-tab -label label="Select template / Reply">
      <div class="pt-4 flex flex-col gap-4 overflow-x-hidden">
        <div class="flex items-start gap-2">
          <mat-form-field appearance="outline" class="flex-1">
            <mat-label >Template</mat-label>
            <mat-select
              [value]="form.controls.templateId.value"
              (selectionChange)="onTemplateSelection($event.value)">
              <mat-option value="" >Custom reply</mat-option>
              @for (group of groupedTemplates; track group.title ?? $index) {
                <mat-optgroup [label]="group.title">
                  @for (template of group.value; track template.id ?? template.name ?? $index) {
                    <mat-option [value]="template.id ?? ''" >
                      {{ template.name || 'Untitled template' }}
                    </mat-option>
                  }
                </mat-optgroup>
              }
            </mat-select>
          </mat-form-field>

            <button
            mat-icon-button
            type="button"
            -aria-label
            aria-label="New template"
              (click)="startCreatingTemplate()"
              [disabled]="savingTemplate() || deletingTemplate() || submittingReply()">
            <mat-icon>add</mat-icon>
          </button>

            @if(review) {
            <button
              mat-icon-button
              type="button"
              -aria-label
              aria-label="Generate with AI"
              (click)="generateWithAi()"
              [disabled]=" savingTemplate() || deletingTemplate() || submittingReply() || generatingComment()"
              [matTooltip]="('Let our AI do the job, just click an a response will be generated for you.')"
              matTooltipPosition="above" >
              <mat-icon>auto_awesome</mat-icon>
            </button>
          }
          @if (selectedTemplate) {
            <button
              mat-icon-button
              type="button"
              -aria-label
              aria-label="Edit template"
              (click)="startEditingTemplate()"
              [disabled]="!canEditSelectedTemplate || savingTemplate() || deletingTemplate() || submittingReply()">
              <mat-icon>edit</mat-icon>
            </button>
          }
        </div>

        @if (loadingTemplates()) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }

        @if (templateError()) {
          <div class="text-sm text-red-600">{{ templateError() }}</div>
        }

        @if (generateCommentError()) {
          <div class="text-sm text-red-600">{{ generateCommentError() }}</div>
        }

        <mat-form-field appearance="outline">
          <mat-label >Reply</mat-label>
          <textarea
            matInput
            rows="6"
            maxlength="5000"
            [formControl]="form.controls.reply"></textarea>
          <mat-hint align="end">{{ form.controls.reply.value.length }}/5000</mat-hint>
          @if (form.controls.reply.touched && form.controls.reply.hasError('required')) {
            <mat-error >Reply is required.</mat-error>
          }
        </mat-form-field>

        @if (submitError()) {
          <div class="text-sm text-red-600" >{{ submitError() }}</div>
        }

        <div class="flex justify-end">
          <button

            mat-flat-button
            color="primary"
            type="button"
            (click)="submitReply()"
            [disabled]="submittingReply() || savingTemplate() || deletingTemplate() || !form.controls.reply.value.trim()">
            Submit reply
          </button>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Create / Edit template">
      <div class="pt-4 flex flex-col gap-4 overflow-x-hidden">
        <div class="flex items-start gap-2">
          <mat-form-field appearance="outline" class="flex-1">
            <mat-label >Template to edit</mat-label>
            <mat-select
              [value]="form.controls.templateId.value"
              (selectionChange)="onTemplateSelectionForManage($event.value)">
              <mat-option value="" >Create new template</mat-option>
              @for (group of groupedTemplates; track group.title ?? $index) {
                @if(group.title === ownGroupLabel) {
                  <mat-optgroup [label]="group.title">
                    @for (template of group.value; track template.id ?? template.name ?? $index) {
                      <mat-option  [value]="template.id ?? ''">
                        {{ template.name || 'Untitled template' }}
                      </mat-option>
                    }
                  </mat-optgroup>
                }
              }
            </mat-select>
          </mat-form-field>

          @if (canManageSelectedTemplate) {
            <button
              mat-icon-button
              type="button"
              -aria-label
              aria-label="Delete template"
              (click)="deleteTemplate()"
              [disabled]="!canDeleteSelectedTemplate || savingTemplate() || deletingTemplate() || submittingReply()">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>

        @if (templateSuccessMessage) {
          <div class="text-sm text-emerald-700" >{{ templateSuccessMessage }}</div>
        }

        @if (templateError()) {
          <div class="text-sm text-red-600" >{{ templateError() }}</div>
        }

        <mat-form-field appearance="outline">
          <mat-label >Template title</mat-label>
          <input matInput [formControl]="form.controls.title" maxlength="255" />
          @if (form.controls.title.touched && !form.controls.title.value.trim()) {
            <mat-error>Title is required to save a template.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label >Template content</mat-label>
          <textarea
            matInput
            rows="6"
            maxlength="5000"
            [formControl]="form.controls.reply"></textarea>
          <mat-hint align="end">{{ form.controls.reply.value.length }}/5000</mat-hint>
          @if (form.controls.reply.touched && form.controls.reply.hasError('required')) {
            <mat-error >Reply is required.</mat-error>
          }
        </mat-form-field>

        <div class="flex justify-end gap-2">
          <button
            mat-flat-button
            color="primary"
            type="button"
            (click)="saveTemplate()"
            [disabled]="savingTemplate() || deletingTemplate() || submittingReply()">
            {{ templateMode === 'edit' ? 'Update template' : 'Save template' }}
          </button>
          <button
            mat-stroked-button
            color="primary"
            type="button"
            (click)="startCreatingTemplate()"
            [disabled]="savingTemplate() || deletingTemplate() || submittingReply()">
            Clear & create new
          </button>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button  mat-stroked-button type="button" (click)="close()" [disabled]="savingTemplate() || deletingTemplate() || submittingReply()">
    Cancel
  </button>
</mat-dialog-actions>
